export default __webpack_public_path__ + "static/media/PinkStar.bb565521.svg";